import type { ExpanderListItem } from '@rio-cloud/rio-uikit/ExpanderList';

import type { ServiceOrder } from '#domain/model/ServiceOrder.ts';

export const getServiceOrderExpanderListItem = (
    serviceOrder: ServiceOrder,
    index: number,
    isSelected: boolean,
    setSelectedIndex: (stopId?: number) => void
): ExpanderListItem => ({
    id: serviceOrder.id,
    header: (
        <div>
            <span className={'uikit-icon icon-wrench text-color-gray text-size-h4 padding-right-10'} />
            <span>{serviceOrder.order} </span>
        </div>
    ),
    open: isSelected,
    onOpen: () => setSelectedIndex(index),
    onClose: () => setSelectedIndex(undefined),
    bodyClassName: 'padding-top-0',
    body: (
        <div className='display-flex flex-column gap-5'>
            <span>{serviceOrder.secondary_reference_id}</span>
            <span>{serviceOrder.note}</span>
        </div>
    ),
});
